import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a8da6cf2")

_pushScopeId("data-v-a8da6cf2")
const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "kn-list--column p-col-4 p-sm-4 p-md-3 p-p-0" }
const _hoisted_4 = {
  class: "kn-list-item",
  "data-test": "list-item"
}
const _hoisted_5 = { class: "kn-list-item-text" }
const _hoisted_6 = { class: "kn-list-item-text-secondary" }
const _hoisted_7 = { class: "kn-list--column p-col-8 p-sm-8 p-md-9 p-p-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_MetadataManagementDetail = _resolveComponent("MetadataManagementDetail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.metadata.title')), 1)
          ]),
          end: _withId(() => [
            _createVNode(_component_KnFabButton, {
              icon: "fas fa-plus",
              onClick: _ctx.showForm,
              "data-test": "open-form-button"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Listbox, {
              key: 1,
              class: "kn-list--column",
              options: _ctx.metadataList,
              filter: true,
              filterPlaceholder: _ctx.$t('common.search'),
              optionLabel: "name",
              filterMatchMode: "contains",
              filterFields: _ctx.metadataManagementDescriptor.filterFields,
              emptyFilterMessage: _ctx.$t('managers.widgetGallery.noResults'),
              onChange: _ctx.showForm,
              "data-test": "metadata-list"
            }, {
              empty: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              option: _withId((slotProps) => [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("span", null, _toDisplayString(slotProps.option.name), 1),
                    _createVNode("span", _hoisted_6, _toDisplayString(slotProps.option.dataType), 1)
                  ]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-trash",
                    class: "p-button-link p-button-sm",
                    onClick: ($event: any) => (_ctx.deleteMetadataConfirm(slotProps.option.id)),
                    "data-test": 'delete-button'
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage", "onChange"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_7, [
        (!_ctx.formVisible)
          ? (_openBlock(), _createBlock(_component_KnHint, {
              key: 0,
              title: 'managers.metadata.title',
              hint: 'managers.metadata.hint'
            }, null, 8, ["title", "hint"]))
          : _createCommentVNode("", true),
        (_ctx.formVisible)
          ? (_openBlock(), _createBlock(_component_MetadataManagementDetail, {
              key: 1,
              model: _ctx.selectedMetadata,
              onClose: _ctx.closeForm,
              onSaved: _ctx.reloadMetadata,
              onTouched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.touched = true))
            }, null, 8, ["model", "onClose", "onSaved"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})